import Ban from 'svg/Ban';
import RacketTwo from 'svg/RacketTwo';
import Trash from 'svg/Trash';
import Button from 'components/Button';
import DetailModalShell from 'components/Find/DetailModalShell';

interface Props {
  isOpen: boolean;
  /** `connection` offers "Invite to play"; `played-with` offers "Connect". */
  variant: 'connection' | 'played-with';
  /** Played-with only: a pending request swaps Connect for Cancel; a spent one hides it. */
  requestState?: 'none' | 'requested' | 'exhausted';
  isSubmitting?: boolean;
  onClose: () => void;
  onPrimaryAction: () => void;
  onCancelRequest?: () => void;
  onBlock: () => void;
  onRemove: () => void;
}

export default function PlayerActionsSheet({
  isOpen,
  variant,
  requestState = 'none',
  isSubmitting = false,
  onClose,
  onPrimaryAction,
  onCancelRequest,
  onBlock,
  onRemove,
}: Props) {
  const isConnection = variant === 'connection';

  return (
    <DetailModalShell isOpen={isOpen} onClose={onClose} title="Actions" hideRequestFooter>
      <div className="flex flex-col gap-ds-lg">
        {isConnection || requestState === 'none' ? (
          <Button
            variant={isConnection ? 'primary' : 'brand'}
            size="lg"
            loading={isSubmitting}
            onClick={onPrimaryAction}
            iconLeft={isConnection ? <RacketTwo className="size-5" /> : undefined}
          >
            {isConnection ? 'Invite to play' : 'Connect'}
          </Button>
        ) : requestState === 'requested' ? (
          <Button variant="secondary" size="lg" loading={isSubmitting} onClick={onCancelRequest}>
            Cancel request
          </Button>
        ) : null}
        <Button
          variant="secondary"
          size="lg"
          onClick={onBlock}
          iconLeft={<Ban className="size-5" />}
        >
          Block player
        </Button>
        <Button
          variant="brand-secondary"
          size="lg"
          onClick={onRemove}
          iconLeft={<Trash className="size-5" />}
        >
          {isConnection ? 'Remove connection' : 'Remove from the list'}
        </Button>
      </div>
    </DetailModalShell>
  );
}
